import { Button, Modal } from "react-bootstrap";
// css
import styles from "./DeleteTasks.module.scss";
import { CloseIcon, DeleteIcon } from "Assets/icons";
import { useDeleteTaskMutation, useGetStaffTaskListLookupQuery } from "store/services/staff";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { NoRecordFound } from "components/Common/Common";
import { useState } from "react";
import { successMessageToast } from "helpers/common";
import ConfirmationPop from "../ConfirmationPop";

const DeleteTasksPop = ({ show, setShow }) => {

    const handlePopup = () => setShow(!show);

    const [currentEntry, setCurrentEntry] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const { data: tasks, isLoading: getTaskLoading, isFetching: getTaskFetching } = useGetStaffTaskListLookupQuery();
    const [deleteTask, { isLoading: deleteTaskLoading }] = useDeleteTaskMutation();

    const handleDelete = async () => {
        try {

            setShowDeleteModal(false);
            const result = await deleteTask(currentEntry?.id);
            if (result.error) return;

            successMessageToast(result?.data?.message);

        } catch (error) { console.log("Error deleting task"); };
    };

    return (
        <>
            <ConfirmationPop
                confirmation={showDeleteModal}
                setConfirmation={setShowDeleteModal}
                confirmHandler={handleDelete}
                type="delete"
            />
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded px-4`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 10, top: 0 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h4 className="m-0 fw-bold themeBlue mb-3">Delete Tasks</h4>
                        {(getTaskFetching || getTaskLoading || deleteTaskLoading) && <LoadingOverlay />}

                        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
                            {
                                !tasks?.length ? <NoRecordFound /> : tasks.map((item, index) => {
                                    return <div key={index} className="d-flex justify-content-between border-bottom w-100">
                                        <div className="d-flex gap-2 align-items-center ">
                                            <h6 className="m-0 text-sm fw-sbold ">{item?.task_title}</h6>
                                        </div>
                                        <div className="py-3">
                                            <Button
                                                disabled={getTaskFetching || getTaskLoading || deleteTaskLoading}
                                                variant="transparent"
                                                style={{ border: "none" }}
                                                onClick={() => {
                                                    setCurrentEntry(item);
                                                    setShowDeleteModal(true);
                                                }}
                                            >
                                                <DeleteIcon style={{ cursor: "pointer" }} />
                                            </Button>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default DeleteTasksPop;
